import { createContext, useContext, useMemo } from "react";

const t = {
  collection: "Wine Collection",
  signIn: "Sign In",
  signOut: "Sign Out",
  heroSubtitle: "ALFREDWINE.COM - WORLD'S BEST",
  heroTitle1: "Global Wine Ratings",
  heroTitle2: "",
  heroDesc: "Discover the World's Finest Wines—Where Exceptional Bottles Are Evaluated, Ranked, and Celebrated.",
  exploreCollection: "Explore Collection",
  curatedWines: "Curated Wines",
  ratingScale: "Rating Scale",
  grapeVarieties: "Grape Varieties",
  featured: "FEATURED",
  premierSelection: "Premier Selection",
  viewAll: "View All",
  categories: "CATEGORIES",
  exploreByStyle: "Explore by Style",
  redWines: "Red Wines",
  whiteWines: "White Wines",
  sparkling: "Sparkling",
  rose: "Rosé",
  exploreSelection: "Explore selection",
  footerText: "Drink responsibly. Must be of legal drinking age.",
  collectionLabel: "COLLECTION",
  wineCatalog: "Wine Catalog",
  winesAvailable: "wines available",
  searchPlaceholder: "Search wines, producers, regions...",
  filters: "Filters",
  allRegions: "All Regions",
  allGrapes: "All Grapes",
  nameAZ: "Name A-Z",
  nameZA: "Name Z-A",
  priceLowHigh: "Price Low-High",
  priceHighLow: "Price High-Low",
  newestFirst: "Newest First",
  oldestFirst: "Oldest First",
  topRated: "Top Rated",
  clear: "Clear",
  noWinesFound: "No wines found",
  tryAdjusting: "Try adjusting your search or filters",
  previous: "Previous",
  next: "Next",
  searchLabel: "Search",
  backToCollection: "Back to Collection",
  scoreOutOf100: "Score out of 100",
  details: "Details",
  tastingNotes: "Tasting Notes",
  tastingCharacteristics: "TASTING CHARACTERISTICS",
  region: "Region",
  producer: "Producer",
  vineyard: "Vineyard",
  grapeVariety: "Grape Variety",
  alcohol: "Alcohol",
  size: "Size",
  bestDrink: "Best Drink",
  temperature: "Temperature",
  price: "Price",
  marketValue: "Market Value",
  loading: "Loading...",
  wineNotFound: "Wine not found",
  goldWorldsBest: "Gold - World's Best",
  goldPremium: "Gold Premium",
  silverHighQuality: "Silver High Quality",
  bronzeQualityWine: "Bronze Quality Wine",
  greenWine: "Green Wine",
  tableWine: "Table Wine",
  poorWine: "Poor Wine",
  faultyWine: "Faulty Wine",
  typeRed: "RED",
  typeWhite: "WHITE",
  typeSparkling: "SPARKLING",
  typeRose: "ROSÉ",
  welcomeBack: "Welcome Back",
  signInToAccount: "Sign in to your account",
  email: "Email",
  password: "Password",
  signingIn: "Signing in...",
  dontHaveAccount: "Don't have an account?",
  createOne: "Create one",
  createAccount: "Create Account",
  createTastingAccount: "Create your tasting account",
  name: "Name",
  creatingAccount: "Creating account...",
  alreadyHaveAccount: "Already have an account?",
  signInLink: "Sign in",
  mv: "MV",
};

const LanguageContext = createContext(null);

// `t` is a module-level constant, so the context value is stable across renders.
const CONTEXT_VALUE = Object.freeze({ t });

export function LanguageProvider({ children }) {
  const value = useMemo(() => CONTEXT_VALUE, []);
  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);

export function getRatingTier(rating, t) {
  if (rating >= 99) return t.goldWorldsBest;
  if (rating >= 95) return t.goldPremium;
  if (rating >= 90) return t.silverHighQuality;
  if (rating >= 86) return t.bronzeQualityWine;
  if (rating >= 81) return t.greenWine;
  if (rating >= 77) return t.tableWine;
  if (rating >= 70) return t.poorWine;
  return t.faultyWine;
}

export function getWineTypeLabel(type, t) {
  const map = { red: t.typeRed, white: t.typeWhite, sparkling: t.typeSparkling, rose: t.typeRose };
  return map[type] || t.typeRed;
}
